import blocks from 'src/js/modules/blocks';
import {
  CONTENT_POSITION_X_CSS_PROPERTY,
  CONTENT_POSITION_Y_CSS_PROPERTY,
} from 'src/js/modules/extensions/registry/ws-image/constants/media-container';
import hasBackgroundContainer from './has-background-container';
import isImageContainer from './is-image-container';
import { getSettings } from '../settings';

const setPosition = (blockNode, position) => {
  const settings = getSettings();
  if (blocks.verifiers.isWsBlock(blockNode)) {
    blockNode.setAttribute('background-position', position);
    return;
  }

  if (hasBackgroundContainer(blockNode)) {
    const backgroundContainer = blockNode.querySelector(settings.backgroundContainer);
    backgroundContainer.setAttribute('position', position);
    return;
  }

  if (isImageContainer(blockNode)) {
    // position may come either as `x% y%` (background format) or `x%_y%` (class format)
    const [x, y] = position.split(/[ _]/);
    blockNode.style.setProperty(CONTENT_POSITION_X_CSS_PROPERTY, x);
    blockNode.style.setProperty(CONTENT_POSITION_Y_CSS_PROPERTY, y);
    blockNode.renderMedia();
  }
};

export default setPosition;
